// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.mission {
  background: var(--light-color);
}

.mission-grid {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 32px;
  margin-bottom: 80px;
}

.mission-card {
  padding: 48px 36px;
  text-align: center;
  background: var(--white);
  transition: var(--transition);
}

.mission-card:hover {
  transform: translateY(-4px);
}

.mission-icon {
  width: 70px;
  height: 70px;
  margin: 0 auto 24px;
  border-radius: 16px;
  background: linear-gradient(135deg, var(--primary-color), var(--secondary-color));
  display: flex;
  align-items: center;
  justify-content: center;
  color: var(--white);
  transition: var(--transition);
}

.mission-icon svg {
  width: 32px;
  height: 32px;
}

.mission-card:hover .mission-icon {
  transform: scale(1.1) rotate(5deg);
}

.mission-title {
  font-size: 22px;
  font-weight: 600;
  margin-bottom: 16px;
  color: var(--dark-color);
}

.mission-description {
  font-size: 15px;
  line-height: 1.8;
  color: var(--text-light);
}

.mission-story {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 64px;
  align-items: center;
  background: var(--white);
  padding: 64px;
  border-radius: 24px;
  box-shadow: var(--shadow-lg);
  border: 1px solid var(--border-color);
}

.story-image {
  position: relative;
  border-radius: 20px;
  overflow: hidden;
  box-shadow: var(--shadow-xl);
}

.story-image img {
  width: 100%;
  height: auto;
  display: block;
  object-fit: cover;
  aspect-ratio: 4/3;
}

.story-badge {
  position: absolute;
  top: 30px;
  right: 30px;
  background: var(--white);
  padding: 20px 24px;
  border-radius: 12px;
  text-align: center;
  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.15);
}

.badge-number {
  display: block;
  font-size: 32px;
  font-weight: 800;
  color: var(--primary-color);
  line-height: 1;
  margin-bottom: 4px;
}

.badge-text {
  font-size: 13px;
  font-weight: 600;
  color: var(--text-color);
}

.story-content {
  display: flex;
  flex-direction: column;
  gap: 20px;
}

.story-title {
  font-size: 36px;
  font-weight: 700;
  color: var(--dark-color);
  margin-bottom: 8px;
}

.story-text {
  font-size: 16px;
  line-height: 1.8;
  color: var(--text-light);
}

.story-features {
  display: flex;
  flex-direction: column;
  gap: 16px;
  margin-top: 12px;
}

.feature-item {
  display: flex;
  align-items: center;
  gap: 12px;
  font-size: 15px;
  font-weight: 500;
  color: var(--text-color);
}

.feature-item svg {
  flex-shrink: 0;
  color: var(--success-color);
}

@media (max-width: 968px) {
  .mission-grid {
    grid-template-columns: 1fr;
    gap: 24px;
  }

  .mission-story {
    grid-template-columns: 1fr;
    gap: 40px;
    padding: 40px;
  }

  .story-title {
    font-size: 28px;
  }
}

@media (max-width: 640px) {
  .mission-card {
    padding: 30px 24px;
  }

  .mission-story {
    padding: 30px 24px;
  }

  .story-badge {
    top: 20px;
    right: 20px;
    padding: 16px 20px;
  }

  .badge-number {
    font-size: 24px;
  }
}

`, "",{"version":3,"sources":["webpack://./src/components/Mission.css"],"names":[],"mappings":"AAAA;EACE,8BAA8B;AAChC;;AAEA;EACE,aAAa;EACb,qCAAqC;EACrC,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,wBAAwB;EACxB,6BAA6B;AAC/B;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,mBAAmB;EACnB,iFAAiF;EACjF,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,mBAAmB;EACnB,6BAA6B;AAC/B;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,kCAAkC;AACpC;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,mBAAmB;EACnB,wBAAwB;AAC1B;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,wBAAwB;AAC1B;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,SAAS;EACT,mBAAmB;EACnB,wBAAwB;EACxB,aAAa;EACb,mBAAmB;EACnB,4BAA4B;EAC5B,qCAAqC;AACvC;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;EACnB,gBAAgB;EAChB,4BAA4B;AAC9B;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,cAAc;EACd,iBAAiB;EACjB,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,WAAW;EACX,wBAAwB;EACxB,kBAAkB;EAClB,mBAAmB;EACnB,kBAAkB;EAClB,2CAA2C;AAC7C;;AAEA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,2BAA2B;EAC3B,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,wBAAwB;AAC1B;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,wBAAwB;EACxB,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,wBAAwB;AAC1B;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,eAAe;EACf,gBAAgB;EAChB,wBAAwB;AAC1B;;AAEA;EACE,cAAc;EACd,2BAA2B;AAC7B;;AAEA;EACE;IACE,0BAA0B;IAC1B,SAAS;EACX;;EAEA;IACE,0BAA0B;IAC1B,SAAS;IACT,aAAa;EACf;;EAEA;IACE,eAAe;EACjB;AACF;;AAEA;EACE;IACE,kBAAkB;EACpB;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,SAAS;IACT,WAAW;IACX,kBAAkB;EACpB;;EAEA;IACE,eAAe;EACjB;AACF","sourcesContent":[".mission {\n  background: var(--light-color);\n}\n\n.mission-grid {\n  display: grid;\n  grid-template-columns: repeat(3, 1fr);\n  gap: 32px;\n  margin-bottom: 80px;\n}\n\n.mission-card {\n  padding: 48px 36px;\n  text-align: center;\n  background: var(--white);\n  transition: var(--transition);\n}\n\n.mission-card:hover {\n  transform: translateY(-4px);\n}\n\n.mission-icon {\n  width: 70px;\n  height: 70px;\n  margin: 0 auto 24px;\n  border-radius: 16px;\n  background: linear-gradient(135deg, var(--primary-color), var(--secondary-color));\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  color: var(--white);\n  transition: var(--transition);\n}\n\n.mission-icon svg {\n  width: 32px;\n  height: 32px;\n}\n\n.mission-card:hover .mission-icon {\n  transform: scale(1.1) rotate(5deg);\n}\n\n.mission-title {\n  font-size: 22px;\n  font-weight: 600;\n  margin-bottom: 16px;\n  color: var(--dark-color);\n}\n\n.mission-description {\n  font-size: 15px;\n  line-height: 1.8;\n  color: var(--text-light);\n}\n\n.mission-story {\n  display: grid;\n  grid-template-columns: 1fr 1fr;\n  gap: 64px;\n  align-items: center;\n  background: var(--white);\n  padding: 64px;\n  border-radius: 24px;\n  box-shadow: var(--shadow-lg);\n  border: 1px solid var(--border-color);\n}\n\n.story-image {\n  position: relative;\n  border-radius: 20px;\n  overflow: hidden;\n  box-shadow: var(--shadow-xl);\n}\n\n.story-image img {\n  width: 100%;\n  height: auto;\n  display: block;\n  object-fit: cover;\n  aspect-ratio: 4/3;\n}\n\n.story-badge {\n  position: absolute;\n  top: 30px;\n  right: 30px;\n  background: var(--white);\n  padding: 20px 24px;\n  border-radius: 12px;\n  text-align: center;\n  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.15);\n}\n\n.badge-number {\n  display: block;\n  font-size: 32px;\n  font-weight: 800;\n  color: var(--primary-color);\n  line-height: 1;\n  margin-bottom: 4px;\n}\n\n.badge-text {\n  font-size: 13px;\n  font-weight: 600;\n  color: var(--text-color);\n}\n\n.story-content {\n  display: flex;\n  flex-direction: column;\n  gap: 20px;\n}\n\n.story-title {\n  font-size: 36px;\n  font-weight: 700;\n  color: var(--dark-color);\n  margin-bottom: 8px;\n}\n\n.story-text {\n  font-size: 16px;\n  line-height: 1.8;\n  color: var(--text-light);\n}\n\n.story-features {\n  display: flex;\n  flex-direction: column;\n  gap: 16px;\n  margin-top: 12px;\n}\n\n.feature-item {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n  font-size: 15px;\n  font-weight: 500;\n  color: var(--text-color);\n}\n\n.feature-item svg {\n  flex-shrink: 0;\n  color: var(--success-color);\n}\n\n@media (max-width: 968px) {\n  .mission-grid {\n    grid-template-columns: 1fr;\n    gap: 24px;\n  }\n\n  .mission-story {\n    grid-template-columns: 1fr;\n    gap: 40px;\n    padding: 40px;\n  }\n\n  .story-title {\n    font-size: 28px;\n  }\n}\n\n@media (max-width: 640px) {\n  .mission-card {\n    padding: 30px 24px;\n  }\n\n  .mission-story {\n    padding: 30px 24px;\n  }\n\n  .story-badge {\n    top: 20px;\n    right: 20px;\n    padding: 16px 20px;\n  }\n\n  .badge-number {\n    font-size: 24px;\n  }\n}\n\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
